export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5236.c9145b3c.jpg";